import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import Dropzone from 'react-dropzone';
import ProgressBar from 'progressbar.js';

import {Form, ErrorContainer, InputWrapper} from 'form';

import ModalFaqBlock from 'components/faq/ModalFaqBlock';

import 'sass/modals/modalAddWallPost.scss';

const UPLOAD_STATE_STANDBY = 'standby';
const UPLOAD_STATE_UPLOADING = 'uploading';
const UPLOAD_STATE_UPLOADED = 'uploaded';

import {uploadWallPost, deleteWallPost, saveWallPost} from 'backend-helpers/member';

import {t} from 'l10n';
import {getMSLength} from 'utils/wallMaterials';
import {Redirect} from "react-router";
import {connect} from "react-redux";

class ModalAddWallPost extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadState: UPLOAD_STATE_STANDBY,
            uploadError: null,
            wallMaterial: null,
        };

        this.onAddClick = this.onAddClick.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onUploadingBlockMounted = this.onUploadingBlockMounted.bind(this);
        this.onUploadProgress = this.onUploadProgress.bind(this);
        this.onUploadCancelClick = this.onUploadCancelClick.bind(this);
        this.onUploadSuccess = this.onUploadSuccess.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onUploadingBlockMounted(uploadingBlock) {
        if (uploadingBlock) {
            this.progressBar = new ProgressBar.Circle(uploadingBlock, {
                strokeWidth: 4,
                easing: 'easeInOut',
                duration: 1400,
                color: 'var(--main-theme-color)',
                trailColor: '#eee',
                trailWidth: 1,
                svgStyle: null,
                step: function(state, circle) {
                  // circle.path.setAttribute('stroke', state.color);
                  // circle.path.setAttribute('stroke-width', state.width);

                  var value = Math.round(circle.value() * 100);
                  if (value === 0) {
                    circle.setText('');
                  } else {
                    circle.setText(value+'%');
                  }

                }
            });
        } else {
            if (this.progressBar) {
                this.progressBar.destroy();
            }
        }

    }

    onAddClick(event) {
        event.preventDefault();
        this.dropzone.open();
    }

    onDrop(files) {
        this.upload(files[0]);
    }

    onUploadProgress(event) {
        this.progressBar.animate(event.loaded / event.total);
    }

    upload(mediaFile) {
        this.setState({
            uploadState: UPLOAD_STATE_UPLOADING,
            uploadError: null
        });

        let {promise, cancelFn, isCancel} = uploadWallPost(mediaFile, this.onUploadProgress);
        this.cancelFn = cancelFn;

        promise.then(this.onUploadSuccess).catch((e) => this.onUploadError(e, isCancel));
    }

    onUploadSuccess({wallMaterial}) {
        this.setState({
            uploadState: UPLOAD_STATE_UPLOADED,
            wallMaterial
        });
    }

    onUploadError(exception, isCancel) {
        if (isCancel(exception)) {
            console.log('Request canceled by user');
        } else {
            this.setState({uploadError: exception.message});
        }
    }

    onUploadCancelClick(event) {
        event.preventDefault();
        this.cancelFn && this.cancelFn();
        this.setState({uploadState: UPLOAD_STATE_STANDBY});
    }

    onDeleteClick(event) {
        event.preventDefault();

        deleteWallPost({id: this.state.wallMaterial.id})
            .then(() => {
                this.setState({uploadState: UPLOAD_STATE_STANDBY, wallMaterial: null});
            })
            .catch((error) => {
                console.log(error);
            });
    }

    onSubmit(formData, setErrors) {
        let {closeFn, onSuccess} = this.props;

        if (!formData.confirmed_adult) {
            setErrors(t('You need confirm that you are owner and the models on your materials are adult.'));
            return false;
        }

        if (!formData.confirmed_publication) {
            setErrors(t('Please confirm that you authorize publication of these files on bobtv.fr'));
            return false;
        }

        saveWallPost(formData)
            .then(() => {
                this.setState({
                    wallMaterial: null,
                    uploadState: UPLOAD_STATE_STANDBY
                });

                closeFn();

                if (typeof onSuccess == 'function') onSuccess();
            })
            .catch((error) => {
                setErrors(error.messages || error.message)
            });
    }

    render() {
        let {show, closeFn} = this.props;
        let {wallMaterial, uploadState} = this.state;

        let {currentUser} = this.props;
        let {router} = this.props;

        const redirectPath = `${router ? router.location.pathname : ''}?login&return_path=${encodeURIComponent(router ? router.location.pathname : '')}`

        if (show && (!currentUser || !currentUser.isLoggedIn()) && router)
            return <Redirect to={redirectPath} />;

        if (router && router.location.search.includes('login')) return <React.Fragment />

        let materialBlock;
        if (uploadState == UPLOAD_STATE_STANDBY) {
            materialBlock = (
                <Dropzone
                    className="add-film-block"
                    activeClassName="active"
                    onDrop={this.onDrop}
                    ref={(ref) => this.dropzone = ref}
                    multiple={false}
                    disableClick={true}
                >
                    <div>
                        <p>{t('Drag your file here...')}</p>
                        <button onClick={this.onAddClick}>{t('Or add from...')}</button>
                    </div>
                </Dropzone>
            );
        } else if (uploadState == UPLOAD_STATE_UPLOADING) {
            materialBlock = (
                <div className="uploading-block">
                    <div className="progress-bar" ref={(ref) => this.onUploadingBlockMounted(ref)}></div>
                    {!this.state.uploadError ? <div className="uploading">{t('Uploading...')}</div> : <div className="upload-error">{this.state.uploadError}</div>}
                    <button onClick={this.onUploadCancelClick}>{t('Cancel')}</button>
                </div>
            )
        } else if (uploadState == UPLOAD_STATE_UPLOADED) {
            let time = getMSLength(wallMaterial, true);

            materialBlock = (
                <div className="save-film-block">
                    <div className="img">
                        <div className="icon-delete" onClick={this.onDeleteClick}></div>
                        {time && <div className="time">{time}</div>}
                        <img src={wallMaterial.thumbnail_url} alt="" />
                    </div>
                    <div className="edit-buttons">
                        <input type="submit" className="save-film" value={t('Confirm your contribution')}/>
                        <button className="delete-uploaded" onClick={this.onDeleteClick}>{t('Delete')}</button>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <Modal className="modalAddWallPost" show={show} onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn}></div>
                        <p className="modal-title">{t('Send to the Wall')}</p>
                        <div className="form">
                            <Form onSubmit={this.onSubmit}>
                                <input type="hidden" name="id" value={wallMaterial ? wallMaterial.id : ''}/>

                                <div className="form-group">
                                    {materialBlock}
                                </div>

                                <ErrorContainer data-errorcontainer={true}/>

                                <div className="form-group">
                                    <label className="mini">{t('Title of your post:')}</label>
                                    <InputWrapper data-formfield={true} type="text" name="title"/>
                                </div>
                                <div className="form-group description">
                                    <label className="mini">{t('Description:')}</label>
                                    <textarea name="description"></textarea>
                                </div>

                                <div className="form-group">
                                    <div className="checkbox">
                                        <input type="checkbox" name="confirmed_adult" id="check_confirmed_adult" />
                                        <label htmlFor="check_confirmed_adult">
                                            {t('I confirm that I am owner of these submitted files. I confirm that models on these materials are over 18 years old.')}
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group m-checkbox">
                                    <div className="checkbox">
                                        <input type="checkbox" name="confirmed_publication" id="check_confirmed_publication" />
                                        <label htmlFor="check_confirmed_publication">
                                            {t('I authorize the publication of this file on bobtv.fr')}
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <ModalFaqBlock items={[
                                            t("Use this form to post your photo or video on the Wall of BobTV."),
                                            t("Your post will appear immediately above the chat rooms and on The Wall. Please note that your video will be available in 5 to 10 minutes after submit because it takes some time to prepare it.")
                                        ]}/>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        router: state.router,
    })
)(ModalAddWallPost);


// WEBPACK FOOTER //
// ./src/components/modals/ModalAddWallPost.js